import { camelToWords } from '@/utils/stringHelper'
import { Flex, Text } from '@chakra-ui/react'

const ToastErrorMessage = ({ issues, details = [] }) => {
  if (!issues && details.length === 0) {
    return <Text>Something goes wrong...</Text>
  }

  if (details.length > 0) {
    return (
      <Flex direction="column" gap="1">
        {details.map((detail, index) => {
          return <Text key={index}>{detail}</Text>
        })}
      </Flex>
    )
  }
  return (
    <Flex direction="column" gap="1">
      {issues.map((issue, index) => {
        if (!Array.isArray(issue.path) || issue.path.length === 0) {
          return (
            <Text key={index} as="b">
              {issue?.message}
            </Text>
          )
        }

        const pathName = issue.path.map((p) => (isNaN(Number(p)) ? camelToWords(p) : String(Number(p) + 1))).join('-')
        return (
          <Flex key={index}>
            <Text as="b">{pathName}: </Text>
            <Text>{issue?.message}</Text>
          </Flex>
        )
      })}
    </Flex>
  )
}

export default ToastErrorMessage
